import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'haufeX360-connector-panel',
    templateUrl: './haufeX360.connector.panel.html'
})
export class HaufeX360ConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Haufe X360',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.HaufeX360Info',
            ControlType: HaufeX360ConnectorPanel,
            Default: {
                AuthType: 0,
                IncludeCustomFields: false
            }
        };
    }

    fldContainsValue(source: string, search: string): boolean {
        return source && source.includes(search);
    }
}
